import { render, staticRenderFns } from "./Aboutme.vue?vue&type=template&id=d5202d08&"
import script from "./Aboutme.vue?vue&type=script&lang=js&"
export * from "./Aboutme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports